import { gql } from 'Utils/apolloClient'

const purchaseCreateMutation = gql`
  mutation PurchaseCreate ($input: PurchaseCreateInput!) {
    purchaseCreate (input: $input) {
      purchase {
        id
        reservation {
          balanceGroupingTotal {
            amount
          }
          balanceTotal {
            amount
          }
          from
          id
          uuid
          source
          pricing {
            currencyCode
          }
          to
        }
      }
    }
  }
`

export default purchaseCreateMutation
